import React, { PropTypes } from 'react';
import styles from './styles.scss';


export const Button = (props) => {
  const {
    className, label, loading, primary, ...rest
  } = props;
  const style = primary ? 'primary--center' : 'secondary--center';

  return (
    <button
      className={`${className} ${styles[style]}`}
      {...rest}
    >
      <div className='contentContainer'>
        {loading
          ? <i className="fa fa-circle-o-notch fa-spin fa-fw" aria-hidden="true" />
          : label
        }
      </div>
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  primary: PropTypes.bool,
  loading: PropTypes.bool,
};


export default Button;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/button/index.jsx